import { Selbstbeteiligung } from '@ps20/bff-models';

export function mapSelbstbeteiligungProzent(
  oldValue: string | Selbstbeteiligung,
): Selbstbeteiligung {
  switch (oldValue) {
    case 'keine':
      return Selbstbeteiligung.SELBSTBETEILIGUNG_0000;
    case '10 %':
      return Selbstbeteiligung.SELBSTBETEILIGUNG_10_PROZENT;
    default:
      return Selbstbeteiligung.SELBSTBETEILIGUNG_20_PROZENT;
  }
}

export function mapSelbstbeteiligung(oldValue: string | Selbstbeteiligung): Selbstbeteiligung {
  switch (oldValue) {
    case '150 €':
      return Selbstbeteiligung.SELBSTBETEILIGUNG_0150;
    case '300 €':
      return Selbstbeteiligung.SELBSTBETEILIGUNG_0300;
    case '500 €':
      return Selbstbeteiligung.SELBSTBETEILIGUNG_0500;
    case '1.000 €':
      return Selbstbeteiligung.SELBSTBETEILIGUNG_1000;
    default:
      return Selbstbeteiligung.SELBSTBETEILIGUNG_0000;
  }
}
